import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";

    export class SecretsOfAnubis2_2Screen extends SlotGameType1_2_2Screen {
      // public PrepareFont(resourceManager: ResourceManager) {
      //   //resourceManager.Add(new FontResource(this.basepath + "resources/huggable.otf", "." + this.resid.ScopedResourceName("font")));
      //   resourceManager.Add(
      //     new FontResource(
      //       this.basepath + "resources/TrajanPro-Bold.otf",
      //       "." + this.resid.ScopedResourceName(["font"])
      //     )
      //   );
      //   resourceManager.Add(
      //     new FontResource(
      //       this.basepath + "resources/TrajanPro-Bold.otf",
      //       this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])
      //     )
      //   );
      // }
  
      public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
       await super.ResourcesLoaded(loadingStage, resourceManager);

        if (loadingStage != LoadingStage.Games) {
            return;
        }
        
  
        //To fix title
        this.title.style.width = Scale.Wpx(1106);
        this.title.style.height = Scale.Hpx(325);
        this.title.style.left = Scale.Xpx(70);
        this.title.style.backgroundSize = "contain";

        

        
      }
      

      
    }